import React from "react";
import { Input, Typography } from "antd";
import { InputContainer } from "./styles";

interface InputComponentProps {
	title?: string;
	style?: React.CSSProperties;
	isRequired?: boolean;
	value?: string | number | undefined;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	placeholder?: string;
	error?: boolean;
	isDisabled?: boolean;
	size?: "small" | "middle" | "large";
	readonly?: boolean;
}

const InputComponent = ({
	title,
	style,
	isRequired = false,
	value = "",
	onChange,
	placeholder = "Lütfen giriniz",
	error = false,
	isDisabled,
	size = "large",
	readonly = false
}: InputComponentProps) => {
	const status = error ? "error" : undefined;

	return (
		<InputContainer>
			{title &&(
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title}
					{isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
				</Typography.Title>
			)}
			<Input
				size={size}
				style={{ 
					width: "160px",
					cursor: readonly ? "not-allowed" : "auto", 
					...style 
				}}
				status={status}
				value={value}
				onChange={onChange}
				disabled={isDisabled}
				placeholder={placeholder}
				readOnly={readonly}
			/>
		</InputContainer>
	);
};

export default InputComponent;
